import uxiliary from "@constants/menu-uxiliary";
import isCRMUser from "@util/isCRMUser";

let menusList = null;

export default (type) => {
  if (menusList === null) {
    menusList = JSON.parse(localStorage.getItem('menuList'));
    if (isCRMUser()) {
      menusList = menusList.chain;
    }
  }
  if (type.indexOf('/') !== -1) {
    return type;
  }
  let ret = '';
  const ids = uxiliary[type];
  for (let i in ids) {
    if (menusList.indexOf(window.parseInt(i)) !== -1) {
      ret = ids[i];
      break;
    }
  }
  return `/hq-web${ret}`;
};



// WEBPACK FOOTER //
// ./src/components/util/getMenuPath.js